import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient.js";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/rej-prog/program";

export const getBreedingProgramPage = createAsyncThunk(
  "breedingProgram/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getBreedingProgramsBySpecies = createAsyncThunk(
  "breedingProgram/bySpecies",
  async ({ speciesList = [] }, { rejectWithValue }) => {
    let programs = [];
    try {
      for (const species of speciesList) {
        const response = await ApiClient.get(
          `${baseUrl}/by-species/${species}`
        );
        programs.push(...response.data);
      }
      return programs;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const allThunks = [getBreedingProgramPage];

const breedingProgramSlice = createSlice({
  name: "breedingProgram",
  initialState: {
    page: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBreedingProgramPage.fulfilled, (state, action) => {
      state.page = action.payload;
    });
    handleLoadingAndErrorState(builder, allThunks);
  },
});

export default breedingProgramSlice.reducer;
